import {CrudService} from '../services/';

export const fetchCourseCategories = (params = {}) => {
    return CrudService._get({
        url: `v1/course-categories`,
        params
    });
};

export const postCourseCategories = (data) => {
    return CrudService._post({
        url: `v1/course-categories/add`,
        data
    });
};

export const putCourseCategories = (data) => {
    return CrudService._put({
        url: `v1/course-categories/edit/${data.id}`,
        data
    });
};

export const deleteCourseCategories = (data) => {

    console.log(data);

    return CrudService._delete({
        url: `v1/course-categories/delete/${data.id}`,
    });
};